import React, { useEffect, useState } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading";
import ResumoFormulario from "../ResumoFormulario";

/* Relatório de um formulário, no mesmo modal cheio do relatório de atividade
   (../StatisticsActivityList/statistics.jsx).

   Duas coisas de lá não vieram junto, de propósito: a lista de seções à
   esquerda, que teria um item só e repetiria o título do modal, e a seção de
   atividades sugeridas, que calcula sugestões a partir do desempenho em
   avaliações — o formulário não alimenta esse cálculo. */

const StatisticsFormulario = ({ show, onClose, formularioId, user }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    let ativo = true;
    setLoading(true);

    axios
      .get(`${URL.api}formulario/${formularioId}/results`, {
        headers: { Authorization: `Bearer ${user.token}` }
      })
      .then(response => {
        if (!ativo) return;
        setData(response.data?.data || null);
      })
      .catch(error => {
        if (!ativo) return;
        toastr.error(
          "Erro",
          error.response?.data?.error ||
            "Não foi possível carregar os resultados do formulário."
        );
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });

    /* O professor fecha e abre o relatório de outro formulário enquanto a resposta do
       primeiro ainda vem; sem esta guarda, a resposta antiga sobrescreve a
       tabela do formulário que está na tela. */
    return () => {
      ativo = false;
    };
  }, [formularioId, user.token]);

  return (
    <CModal
      size="lg w-100 h-100 m-0 p-2 mw-100"
      style={{ width: "100%", height: "100%" }}
      show={show}
      onClose={() => onClose()}
      closeOnBackdrop={false}
    >
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loading />
        </div>
      ) : (
        <>
          <CModalHeader closeButton>
            <CModalTitle className="stat-report-modal-title">
              Resumo do formulário
            </CModalTitle>
          </CModalHeader>
          <CModalBody
            className="p-0"
            style={{ overflow: "auto", background: "#f5f7fa" }}
          >
            <ResumoFormulario data={data} />
          </CModalBody>
        </>
      )}
    </CModal>
  );
};

const mapStateToProps = state => ({ user: state.user });

export default connect(mapStateToProps)(StatisticsFormulario);
